import React, { FC } from "react";
import InputData from "./InputData";
import Results from "./Results";

interface IApplDetails {
  result: any;
  inputData: any;
}

const ApplDetails: FC<IApplDetails> = ({ result, inputData }) => {

  return (
    <div id="calc-details" className="calc-details">
      <InputData data={inputData} />
      <Results data={result} />
      {/* <div className="download">
        <button className="btn" onClick={handleDownload}>
          Download
        </button>
      </div> */}
    </div>
  );
};

export default ApplDetails;
